import i18next from 'i18next';

interface ZendeskAPI {
    livechat: {
        setGreetings: (greetings: { online: string; offline: string }) => void;
        prechatForm: {
            setGreetings: (message: string) => void;
        };
        setLanguage: (lang: string) => void;
        setColor: (color: string) => void;
        setStatus: (status: 'online' | 'offline') => void;
        status: () => 'online' | 'offline';
    };
}

interface ZopimFunction extends Function {
    _: any[];
    set: {
        _: any[];
        push: (obj: unknown) => void;
    };
    s: HTMLScriptElement;
    t: number;
}

declare global {
    interface Window {
        $zopim?: ((callback: () => void) => void) & {
            livechat: ZendeskAPI['livechat'];
        };
    }
    var $zopim: ((callback: () => void) => void) & {
        livechat: ZendeskAPI['livechat'];
    };
}

export const initZendesk = () => {
    const ZENDESK_KEY = '1wq7D2sf6yYPu5Aj8IEq8KS0Cuie4q4E';

    window.$zopim ||
        (function (d: Document, s: string) {
            const z = function (c: () => void) {
                (z as ZopimFunction)._.push(c);
            } as unknown as ZopimFunction;

            z._ = [];
            z.set = { _: [], push: function (o) { z.set._.push(o); } };

            const script = d.createElement(s) as HTMLScriptElement;
            const first = d.getElementsByTagName(s)[0];

            script.async = true;
            script.charset = 'utf-8';
            script.src = `https://v2.zopim.com/?${ZENDESK_KEY}`;
            script.type = 'text/javascript';

            z.t = +new Date();
            first.parentNode?.insertBefore(script, first);

            window.$zopim = z as any;
        })(document, 'script');
};

export const configureZendesk = (language: string, title: string, onlineText: string, offlineText: string) => {
    window.$zopim?.(() => {
        window.$zopim?.livechat.setGreetings({
            online: onlineText,
            offline: offlineText,
        });

        window.$zopim?.livechat.prechatForm.setGreetings(
            title
        );

        window.$zopim?.livechat.setLanguage(language);

        window.$zopim?.(() => {
            if (window.$zopim?.livechat && window.$zopim.livechat.status !== undefined) {
                const status = window.$zopim.livechat.status();
                if (status === 'online') {
                    window.$zopim.livechat.setColor('#4CAF50');
                } else {
                    window.$zopim.livechat.setColor('#9E9E9E');
                }
            }
        });
    });
}; 